/*
 * Copyright (c) 2019 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

export function toPromise<T>(delegate: () => T | Promise<T>): Promise<T> {
  try {
    const result = delegate();
    return result instanceof Promise ? result : Promise.resolve(result);
  } catch (error) {
    return Promise.reject(error);
  }
}
